// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseButton_close___6AbQ"};